import { useEffect, useState } from 'react';

interface UsePageAnimationProps {
  key: string;
  containerRef: React.RefObject<HTMLElement>;
}

export const usePageAnimation = ({ key, containerRef }: UsePageAnimationProps) => {
  const [renderedKey, setRenderedKey] = useState('');

  useEffect(() => {
    if (key === renderedKey) return;

    const el = containerRef?.current;
    if (!el) {
      setRenderedKey(key);
      return;
    }

    let animation: Animation | null = null;
    el.style.opacity = '0';

    if (typeof el.animate === 'function') {
      animation = el.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 200,
        easing: 'ease',
        fill: 'forwards',
      });

      animation.onfinish = () => {
        setRenderedKey(key);
      };
    } else {
      // Fallback: instantly show without animation
      el.style.opacity = '1';
      setRenderedKey(key);
    }

    return () => {
      animation?.cancel();
      el.style.opacity = '1';
    };
  }, [key, renderedKey, containerRef]);
};
